import { Trans } from '@lingui/macro';
import { useNumberFormat } from 'hooks/useNumberFormat';
import styles from './NoAvailableFundsSubheading.module.css';

type TProps = {
  offeredAmount?: number;
};

export const NoAvailableFundsSubheading = ({ offeredAmount }: TProps) => {
  const { formatCurrency } = useNumberFormat();

  return (
    <>
      <p className={styles.noAvailableFundsSubheading}>
        <Trans>
          Whilst our credit assessment of your client is positive, the offer
          amount of {formatCurrency(offeredAmount)} is less than their current
          balance.
        </Trans>
      </p>
      <p className={styles.noAvailableFundsSubheading}>
        <Trans>
          Unfortunately this means there are no available funds to draw down at
          this time.
        </Trans>
      </p>
    </>
  );
};
